var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-header",
        { staticClass: "de-header" },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("Toolbar", {
                ref: "toolbar",
                attrs: {
                  "style-button-active": _vm.show && _vm.showIndex === 2,
                  "aided-button-active": _vm.aidedButtonActive,
                },
                on: {
                  showPanel: _vm.showPanel,
                  previewFullScreen: _vm.previewFullScreen,
                  changeAidedDesign: _vm.changeAidedDesign,
                  outerParamsSetVisibleChange: _vm.outerParamsSetVisibleChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "de-container",
        [
          _c("de-aside-container", { staticClass: "ms-aside-container" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showAside,
                    expression: "showAside",
                  },
                ],
                staticStyle: {
                  width: "60px",
                  left: "0px",
                  top: "0px",
                  bottom: "0px",
                  position: "absolute",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "60px",
                      height: "100%",
                      overflow: "hidden auto",
                      position: "relative",
                      margin: "0px auto",
                      "font-size": "14px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button-div-class",
                        staticStyle: {
                          width: "24px",
                          height: "24px",
                          "text-align": "center",
                          "line-height": "1",
                          position: "relative",
                          margin: "16px auto 0px",
                        },
                      },
                      [
                        _c("el-button", {
                          staticClass: "el-icon-circle-plus-outline",
                          attrs: { circle: "", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.newChart()
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "button-text",
                        staticStyle: {
                          position: "relative",
                          margin: "18px auto 16px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "max-width": "100%",
                              "text-align": "center",
                              "white-space": "nowrap",
                              "text-overflow": "ellipsis",
                              position: "relative",
                              "flex-shrink": "0",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("panel.view")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "1px",
                          position: "relative",
                          margin: "0px auto",
                          "background-color": "#E6E6E6",
                        },
                      },
                      [
                        _c("div", {
                          staticStyle: {
                            width: "60px",
                            height: "1px",
                            "line-height": "1px",
                            "text-align": "center",
                            "white-space": "pre",
                            "text-overflow": "ellipsis",
                            position: "relative",
                            "flex-shrink": "0",
                          },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "button-div-class",
                        staticStyle: {
                          width: "24px",
                          height: "24px",
                          "text-align": "center",
                          "line-height": "1",
                          position: "relative",
                          margin: "16px auto 0px",
                        },
                      },
                      [
                        _c("el-button", {
                          staticClass: "el-icon-s-tools",
                          class:
                            _vm.show && _vm.showIndex === 1
                              ? "button-show"
                              : "button-closed",
                          attrs: { circle: "", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.showPanel(1)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "button-text",
                        staticStyle: {
                          position: "relative",
                          margin: "18px auto 16px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "max-width": "100%",
                              "text-align": "center",
                              "white-space": "nowrap",
                              "text-overflow": "ellipsis",
                              position: "relative",
                              "flex-shrink": "0",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("panel.module")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "1px",
                          position: "relative",
                          margin: "0px auto",
                          "background-color": "#E6E6E6",
                        },
                      },
                      [
                        _c("div", {
                          staticStyle: {
                            width: "60px",
                            height: "1px",
                            "line-height": "1px",
                            "text-align": "center",
                            "white-space": "pre",
                            "text-overflow": "ellipsis",
                            position: "relative",
                            "flex-shrink": "0",
                          },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "button-div-class",
                        staticStyle: {
                          width: "24px",
                          height: "24px",
                          "text-align": "center",
                          "line-height": "1",
                          position: "relative",
                          margin: "16px auto 0px",
                        },
                      },
                      [
                        _c("el-button", {
                          staticClass: "el-icon-brush",
                          class:
                            _vm.show && _vm.showIndex === 3
                              ? "button-show"
                              : "button-closed",
                          attrs: { circle: "", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.showPanel(3)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "button-text",
                        staticStyle: {
                          position: "relative",
                          margin: "18px auto 16px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "max-width": "100%",
                              "text-align": "center",
                              "white-space": "nowrap",
                              "text-overflow": "ellipsis",
                              position: "relative",
                              "flex-shrink": "0",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("panel.other_module")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "1px",
                          position: "relative",
                          margin: "0px auto",
                          "background-color": "#E6E6E6",
                        },
                      },
                      [
                        _c("div", {
                          staticStyle: {
                            width: "60px",
                            height: "1px",
                            "line-height": "1px",
                            "text-align": "center",
                            "white-space": "pre",
                            "text-overflow": "ellipsis",
                            position: "relative",
                            "flex-shrink": "0",
                          },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "button-div-class",
                        staticStyle: {
                          width: "24px",
                          height: "24px",
                          "text-align": "center",
                          "line-height": "1",
                          position: "relative",
                          margin: "16px auto 0px",
                        },
                      },
                      [
                        _c("el-button", {
                          staticClass: "el-icon-copy-document button-closed",
                          attrs: { circle: "", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.showMultiplexing(true)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "button-text",
                        staticStyle: {
                          position: "relative",
                          margin: "18px auto 16px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "max-width": "100%",
                              "text-align": "center",
                              "white-space": "nowrap",
                              "text-overflow": "ellipsis",
                              position: "relative",
                              "flex-shrink": "0",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("panel.multiplexing")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "1px",
                          position: "relative",
                          margin: "0px auto",
                          "background-color": "#E6E6E6",
                        },
                      },
                      [
                        _c("div", {
                          staticStyle: {
                            width: "60px",
                            height: "1px",
                            "line-height": "1px",
                            "text-align": "center",
                            "white-space": "pre",
                            "text-overflow": "ellipsis",
                            position: "relative",
                            "flex-shrink": "0",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _c(
            "de-main-container",
            { attrs: { id: "canvasInfo-main" } },
            [
              _c(
                "el-drawer",
                {
                  staticStyle: { position: "absolute" },
                  attrs: {
                    visible: _vm.show,
                    "with-header": false,
                    direction: "ltr",
                    modal: false,
                    size: _vm.drawerSize,
                    "wrapper-closable": false,
                    "close-on-press-escape": false,
                    "modal-append-to-body": true,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.show = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "295px" } },
                    [
                      _c("filter-group", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.show && _vm.showIndex === 1,
                            expression: " show &&showIndex===1",
                          },
                        ],
                        attrs: { "canvas-id": _vm.canvasId },
                      }),
                      _c("subject-setting", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.show && _vm.showIndex === 2,
                            expression: " show &&showIndex===2",
                          },
                        ],
                      }),
                      _c("assist-component", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.show && _vm.showIndex === 3,
                            expression: " show &&showIndex===3",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ]
              ),
              !_vm.previewVisible && !_vm.mobileLayoutStatus
                ? _c("canvas-opt-bar")
                : _vm._e(),
              !_vm.previewVisible && !_vm.mobileLayoutStatus
                ? _c("de-canvas", {
                    ref: "canvasMainRef",
                    staticClass: "canvas_main_content",
                    style: _vm.customCanvasStyle,
                    attrs: {
                      "canvas-style-data": _vm.canvasStyleData,
                      "component-data": _vm.mainCanvasComponentData,
                      "canvas-id": _vm.canvasId,
                      "canvas-pid": "0",
                    },
                    on: { canvasScroll: _vm.canvasScroll },
                  })
                : _vm._e(),
              _vm.mobileLayoutStatus
                ? _c(
                    "el-row",
                    { staticClass: "mobile_canvas_main" },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "this_mobile_canvas_cell",
                          attrs: { span: 8 },
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "proportion",
                                  rawName: "v-proportion",
                                  value: 2.1,
                                  expression: "2.1",
                                },
                              ],
                              staticClass: "this_mobile_canvas",
                              style: _vm.customCanvasMobileStyle,
                            },
                            [
                              _c("el-row", {
                                staticClass: "this_mobile_canvas_top",
                              }),
                              _c(
                                "el-row",
                                { staticClass: "this_mobile_canvas_inner_top" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.panelInfo.name) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _c(
                                "el-row",
                                {
                                  staticClass: "this_mobile_canvas_main",
                                  style: _vm.mobileCanvasStyle,
                                  attrs: { id: "canvasInfoMobile" },
                                },
                                [
                                  !_vm.previewVisible && _vm.mobileLayoutStatus
                                    ? _c("canvas-opt-bar")
                                    : _vm._e(),
                                  !_vm.previewVisible && _vm.mobileLayoutStatus
                                    ? _c("de-canvas", {
                                        ref: "canvasMainRef",
                                        attrs: {
                                          "canvas-style-data":
                                            _vm.canvasStyleData,
                                          "component-data":
                                            _vm.mainCanvasComponentData,
                                          "canvas-id": _vm.canvasId,
                                          "canvas-pid": "0",
                                          "mobile-layout-status": true,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                {
                                  staticClass:
                                    "this_mobile_canvas_inner_bottom",
                                },
                                [
                                  _c("el-col", { attrs: { span: 12 } }, [
                                    !_vm.hasStar
                                      ? _c("i", {
                                          staticClass: "el-icon-star-off",
                                          attrs: { size: "mini" },
                                          on: { click: _vm.star },
                                        })
                                      : _vm._e(),
                                    _vm.hasStar
                                      ? _c("i", {
                                          staticClass: "el-icon-star-on",
                                          staticStyle: {
                                            color: "#0a7be0",
                                            "font-size": "18px",
                                          },
                                          attrs: { size: "mini" },
                                          on: { click: _vm.unstar },
                                        })
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { float: "right" },
                                      attrs: { span: 12 },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-refresh-right",
                                        attrs: { size: "mini" },
                                        on: { click: _vm.mobileRefresh },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("el-row", {
                                staticClass: "this_mobile_canvas_bottom",
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-col",
                        {
                          staticClass:
                            "this_mobile_canvas_cell this_mobile_canvas_wait_cell",
                          attrs: { span: 16 },
                        },
                        [_c("component-wait")],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.mobileLayoutStatus && _vm.rightDrawOpen,
                  expression: "!mobileLayoutStatus&&rightDrawOpen",
                },
              ],
              staticClass: "tools-window-main",
            },
            [
              _vm.showViewToolsAside
                ? _c(
                    "div",
                    [
                      _c("chart-edit", {
                        ref: "chartEditRef",
                        attrs: {
                          "edit-status":
                            _vm.showViewToolsAside &&
                            !_vm.mobileLayoutStatus &&
                            _vm.rightDrawOpen,
                          "edit-from": "panel",
                          param: _vm.chartEditParam,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showBatchViewToolsAside
                ? _c("div", [_c("chart-style-batch-set")], 1)
                : _vm._e(),
              !_vm.showViewToolsAside && !_vm.showBatchViewToolsAside
                ? _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { staticStyle: { height: "40px" } },
                        [
                          _c(
                            "el-tooltip",
                            { attrs: { content: _vm.$t("chart.draw_back") } },
                            [
                              _c("el-button", {
                                staticClass: "el-icon-d-arrow-right",
                                staticStyle: {
                                  position: "absolute",
                                  left: "4px",
                                  top: "5px",
                                },
                                attrs: { size: "mini", circle: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeRightDrawOpen(false)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.curComponent && !_vm.curComponent.auxiliaryMatrix
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "14px",
                                    "margin-left": "40px",
                                    "line-height": "40px",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("panel.position_adjust"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _vm.curComponent && !_vm.curComponent.auxiliaryMatrix
                            ? _c("position-adjust")
                            : _c(
                                "div",
                                { staticClass: "view-selected-message-class" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        "margin-left": "10px",
                                        "font-weight": "bold",
                                        "line-height": "20px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("panel.select_view")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _vm.buttonVisible && _vm.panelInfo.id
        ? _c(
            "el-dialog",
            {
              attrs: {
                title:
                  (_vm.currentWidget &&
                  _vm.currentWidget.getLeftPanel &&
                  _vm.currentWidget.getLeftPanel().label
                    ? _vm.$t(_vm.currentWidget.getLeftPanel().label)
                    : "") + _vm.$t("panel.module"),
                visible: _vm.buttonVisible,
                "custom-class": "de-button-dialog",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.buttonVisible = $event
                },
                close: _vm.cancelButton,
              },
            },
            [
              _vm.buttonVisible &&
              _vm.currentWidget &&
              _vm.currentWidget.name === "buttonSureWidget"
                ? _c("button-dialog", {
                    ref: "filter-setting-" + _vm.currentFilterCom.id,
                    attrs: {
                      "widget-info": _vm.currentWidget,
                      element: _vm.currentFilterCom,
                    },
                    on: {
                      "sure-handler": _vm.sureHandler,
                      "cancel-handler": _vm.cancelHandler,
                    },
                  })
                : _vm._e(),
              _vm.buttonVisible &&
              _vm.currentWidget &&
              _vm.currentWidget.name === "buttonResetWidget"
                ? _c("button-reset-dialog", {
                    ref: "filter-setting-" + _vm.currentFilterCom.id,
                    attrs: {
                      "widget-info": _vm.currentWidget,
                      element: _vm.currentFilterCom,
                    },
                    on: {
                      "reset-button-handler": _vm.sureHandler,
                      "cancel-button-handler": _vm.cancelHandler,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.filterVisible && _vm.panelInfo.id
        ? _c(
            "el-dialog",
            {
              attrs: {
                title:
                  (_vm.currentWidget &&
                  _vm.currentWidget.getLeftPanel &&
                  _vm.currentWidget.getLeftPanel().label
                    ? _vm.$t(_vm.currentWidget.getLeftPanel().label)
                    : "") + _vm.$t("panel.module"),
                visible: _vm.filterVisible,
                "custom-class": "de-filter-dialog",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.filterVisible = $event
                },
                close: _vm.cancelFilter,
              },
            },
            [
              _vm.filterVisible && _vm.currentWidget
                ? _c("filter-dialog", {
                    ref: "filter-setting-" + _vm.currentFilterCom.id,
                    attrs: {
                      "widget-info": _vm.currentWidget,
                      element: _vm.currentFilterCom,
                    },
                    on: {
                      "sure-button-status": _vm.sureStatusChange,
                      "re-fresh-component": _vm.reFreshComponent,
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "end !important",
                    margin: "0 15px 10px !important",
                  },
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.cancelFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("commons.cancel")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: !_vm.enableSureButton,
                            type: "primary",
                            size: "mini",
                          },
                          on: { click: _vm.sureFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("commons.confirm")))]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "fullscreen",
        {
          staticStyle: {
            height: "100%",
            background: "#f7f8fa",
            "overflow-y": "auto",
          },
          attrs: { fullscreen: _vm.previewVisible },
          on: {
            "update:fullscreen": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _vm.previewVisible
            ? _c("Preview", {
                attrs: {
                  "in-screen": !_vm.previewVisible,
                  "panel-info": _vm.panelInfo,
                  "show-type": _vm.canvasStyleData.selfAdaption
                    ? "full"
                    : "width",
                  "canvas-style-data": _vm.canvasStyleData,
                  "component-data": _vm.mainCanvasComponentData,
                  "show-position": "edit",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("input", {
        ref: "files",
        attrs: { id: "input", type: "file", accept: "image/*", hidden: "" },
        on: {
          click: function (e) {
            e.target.value = ""
          },
          change: _vm.handleFileChange,
        },
      }),
      _c("ChartGroup", {
        ref: "chartGroup",
        staticStyle: {
          height: "0px",
          width: "0px",
          padding: "0px",
          overflow: "hidden",
        },
        attrs: {
          "opt-from": "panel",
          "advice-group-id": _vm.adviceGroupId,
          "mounted-init": false,
        },
        on: { newViewInfo: _vm.newViewInfo },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-css",
          attrs: {
            visible: _vm.outerParamsSetVisible,
            width: "900px",
            "show-close": true,
            "destroy-on-close": true,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.outerParamsSetVisible = $event
            },
          },
        },
        [
          _vm.outerParamsSetVisible
            ? _c("OuterParamsSet", {
                on: {
                  outerParamsSetVisibleChange: _vm.outerParamsSetVisibleChange,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-css",
          attrs: {
            visible: _vm.multiplexingShow,
            "show-close": false,
            fullscreen: true,
          },
        },
        [
          _vm.multiplexingShow
            ? _c("multiplexing", { attrs: { "view-data": _vm.viewData } })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer title-text",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("span", { staticStyle: { "font-size": "14px" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("panel.multiplexing")) +
                    "\n      "
                ),
              ]),
              _c(
                "span",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.saveMultiplexing()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("commons.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.showMultiplexing(false)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("commons.cancel")))]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.panelCacheExist,
            title: _vm.$t("panel.panel_no_save_tips"),
            "show-close": false,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.panelCacheExist = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { height: "20px" } },
            [
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c("svg-icon", {
                    staticStyle: {
                      width: "20px",
                      height: "20px",
                      float: "right",
                    },
                    attrs: { "icon-class": "warn-tree" },
                  }),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 21 } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "13px",
                      "margin-left": "10px",
                      "font-weight": "bold",
                      "line-height": "20px",
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("panel.panel_cache_use_tips")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.useCache(false)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("panel.no")) + "\n      ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.useCache(true)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("panel.yes")) + "\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showAttr && _vm.curComponent.canvasId === "canvas-main"
        ? _c("text-attr", {
            attrs: {
              "canvas-id": _vm.canvasId,
              "scroll-left": _vm.scrollLeft,
              "scroll-top": _vm.scrollTop,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }